import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

@Component({
	selector: "app-button-download",
	templateUrl: "button-download.component.html",
})
export class ButtonDownloadComponent implements OnInit {
	@Output() public click = new EventEmitter();
	@Input() public isDownloading = false;
	constructor() {}

	ngOnInit() {}
	telecharger() {
		this.click.emit();
	}
}
